import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import HeaderLogin from "../../layout/Header/HeaderLogin";
import GeneralModal from "../../modals/GeneralModal";
import { AuthService } from "../../../services/auth.service";

export default function Login() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [formData, setFormData] = useState({
        email: "",      // เปลี่ยนจาก username เป็น email ตาม API
        password: "",
    });
    const [errors, setErrors] = useState({
        email: "",
        password: "",
    });
    const [modalState, setModalState] = useState({
        visible: false,
        message: "",
        isSuccess: false
    });

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setErrors(prev => ({
            ...prev,
            [name]: ""
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!validateEmail(formData.email)) {
            newErrors.email = "Invalid email address";
        }

        if (!formData.password) {
            newErrors.password = "Password is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;
    
        setIsLoading(true);

        try {
            const response = await axios.post(
                `${import.meta.env.VITE_API_URL}/auth/login`,
                {
                    email: formData.email.trim(),
                    password: formData.password
                }
            );
    
            // จัดการ response ผ่าน AuthService
            AuthService.handleLoginSuccess(response.data);
            // AuthService.checkAuthStatus();
    
            setModalState({
                visible: true,
                message: "Login successful!",
                isSuccess: true
            });
    
            setTimeout(() => {
                navigate("/");
            }, 1500);
            
        } catch (error) {
            console.error('Login Error:', error);
            
            let errorMessage = "An error occurred. Please try again.";
            
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        errorMessage = "Invalid email or password";
                        break;
                    case 403:
                        errorMessage = "Account is inactive";
                        break;
                    default:
                        errorMessage = error.response.data.message || errorMessage;
                }
            }
    
            setModalState({
                visible: true,
                message: errorMessage,
                isSuccess: false
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col justify-between bg-gray-100">
            <GeneralModal
                isVisible={modalState.visible}
                message={modalState.message}
                isSuccess={modalState.isSuccess}
                onClose={() => setModalState(prev => ({ ...prev, visible: false }))}
            />
            
            <HeaderLogin />
            
            <div className="flex items-center justify-center flex-grow py-8">
                <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-md p-8 w-full max-w-md mx-4">
                    <div className="mb-8 flex justify-center">
                        <img src="/content.png" alt="Logo" className="w-24 h-auto" />
                    </div>
                    
                    <h2 className="text-2xl font-bold text-center mb-6">Sign in to your account</h2>
                    
                    <div className="space-y-4">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                Email
                            </label>
                            <input
                                id="email"
                                name="email"
                                type="text"
                                value={formData.email}
                                onChange={handleInputChange}
                                className={`input input-bordered w-full ${errors.email ? "border-red-500" : ""}`}
                                placeholder="Enter your email"
                                disabled={isLoading}
                            />
                            {errors.email && (
                                <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                            )}
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                                Password
                            </label>
                            <div className="relative">
                                <input
                                    id="password"
                                    name="password"
                                    type={passwordVisible ? "text" : "password"}
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    className={`input input-bordered w-full pr-10 ${errors.password ? "border-red-500" : ""}`}
                                    placeholder="Enter your password"
                                    disabled={isLoading}
                                />
                                <button
                                    type="button"
                                    onClick={togglePasswordVisibility}
                                    className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                    disabled={isLoading}
                                >
                                    <i className={`fas ${passwordVisible ? "fa-eye-slash" : "fa-eye"} text-gray-500`}></i>
                                </button>
                            </div>
                            {errors.password && (
                                <p className="text-red-500 text-sm mt-1">{errors.password}</p>
                            )}
                        </div>

                        <div className="flex justify-end">
                            <a href="/forget-password" className="text-sm text-blue-600 hover:text-blue-800">
                                Forgot Password?
                            </a>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary w-full bg-black hover:bg-gray-800"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <span className="flex items-center justify-center">
                                    <i className="fas fa-spinner fa-spin mr-2"></i>
                                    Signing in...
                                </span>
                            ) : (
                                'Sign in'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}